import { useQuery } from '@tanstack/react-query';
import { rejectedRequestCount } from '../api/rejectedRequests';
import { usePermission } from '../auth/usePermission';

export const REJECTED_REQUESTS_COUNT_QUERY_KEY = ['rejected-requests', 'count'];
const SEEN_KEY = 'rejected-requests-seen-at';

export const getRejectedSeenAt = () => {
  try {
    return localStorage.getItem(SEEN_KEY);
  } catch {
    return null;
  }
};

export const markRejectedSeen = () => {
  try {
    localStorage.setItem(SEEN_KEY, new Date().toISOString());
  } catch {
    /* storage unavailable — badge just stays until next load */
  }
};

/** Requests of the user's that were rejected since they last opened the Rejected Requests page. */
export function useRejectedRequestCount() {
  const { can } = usePermission();
  const enabled = can(['candidates.bulk-requests', 'passport-requests.create', 'accommodation-requests.create']);

  const query = useQuery({
    queryKey: REJECTED_REQUESTS_COUNT_QUERY_KEY,
    queryFn: () => rejectedRequestCount(getRejectedSeenAt()),
    enabled,
    refetchInterval: 60_000,
  });

  return enabled ? (query.data ?? 0) : 0;
}
